import Address from './Address';
import Util from './Util';

/**
 * Represents a partial address-input where the address-type is one of the types listed at:
 * https://developers.google.com/maps/documentation/geocoding/intro#Types
 * It triggers the following Google API event:
 * - 'input_changed': when the partial-input-value was changed
 */
export default class PartialAddressInput {

    /**
     * Setup the partial-input and its events.
     * @param {string} addressType type of the address-part.
     * @param {Element} inputElement input element.
     */
    constructor(addressType, inputElement) {

        // setup class members
        let that = this;
        this.addressType = addressType;
        this.inputElement = inputElement;
        this.tempValue = inputElement.value;
        this.inputTimer = null;

        // on key-up sets up a timer to change the input when the address-type is 'street_number'
        google.maps.event.addDomListener(this.inputElement, 'keyup', function(event) {
            let keycode = (event.keyCode ? event.keyCode : event.which);
            let value = this.value;
            clearTimeout(that.inputTimer);
            // only trigger when the value changed
            if (that.tempValue !== value) {
                if (keycode === 13) { // ENTER
                    that.tempValue = value;
                    google.maps.event.trigger(that, 'input_changed');
                } else if (that.addressType === 'street_number') {
                    that.inputTimer = setTimeout(function () {
                        that.tempValue = value;
                        google.maps.event.trigger(that, 'input_changed');
                    }, 1000);
                }
            }
        });

        // store the current input-value as a temporary value when the input is focussed.
        google.maps.event.addDomListener(this.inputElement, 'focus', function() {
            that.tempValue = this.value;
        });

        // change the input when the input-element is blurred and its value did change
        google.maps.event.addDomListener(this.inputElement, 'blur', function() {
            clearTimeout(that.inputTimer);
            if (that.tempValue !== this.value) {
                google.maps.event.trigger(that, 'input_changed');
            }
        });
    }

    /**
     * Get the address-type.
     * @returns {string} address-type
     */
    getType() {
        return this.addressType;
    }

    /**
     * Get the input-value.
     * @returns {string} input-value
     */
    getValue() {
        return this.inputElement.value;
    }

    /**
     * Clear the address-input.
     * @returns {null} null
     */
    clear() {
        this.inputElement.value = '';
    }

    /**
     * Set a new address for the partial-input or clears the input if the address is empty.
     * @param {Address|null} address the address
     * @returns {null} null
     */
    setAddress(address = null) {
        if (address instanceof Address) {
            this.inputElement.value = (address.hasOwnProperty(this.addressType) ? address[this.addressType] : '');
        } else {
            this.inputElement.value = '';
        }
    }
}